import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#0348a9")};
  background-color: ${(props) => (props.border ? "transparent" : "#0348a9")};
  width: 100%;
  padding: 15px;
  outline: none;
  border-radius: 6rem;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  font-size: 0.813rem;
`;

